import React, { useEffect, useState } from "react";
import { getIndividualPricing } from "../api";

/**
 * Monthly vs yearly chooser, shown only where someone is actually deciding to
 * pay — the paywall after a trial, or an upgrade during one.
 *
 * Deliberately not shown at signup or when starting a free trial: nothing is
 * charged there, so the choice would be a price tag on a $0 step.
 *
 * Renders nothing until pricing loads (best-effort — the server still defaults
 * to monthly if the caller sends no plan).
 */
export default function PlanPicker({ plan, onChange, className = "" }) {
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    getIndividualPricing().then(setPricing).catch(() => {});
  }, []);

  if (!pricing) return null;

  const options = [
    {
      value: "monthly",
      label: "Monthly",
      price: `$${(pricing.monthly_price_cents / 100).toFixed(2)}/mo`,
      note: "billed monthly",
    },
    {
      value: "yearly",
      label: "Yearly",
      price: `$${(pricing.yearly_monthly_price_cents / 100).toFixed(2)}/mo`,
      note: `$${(pricing.yearly_charge_cents / 100).toFixed(2)} billed yearly`,
    },
  ];

  return (
    <div className={`flex gap-3 ${className}`}>
      {options.map(({ value, label, price, note }) => (
        <label
          key={value}
          className={`flex-1 flex flex-col items-center px-3 py-2 rounded-xl border cursor-pointer text-sm font-medium transition-colors ${
            plan === value
              ? "border-emerald-500 bg-emerald-50 text-emerald-700"
              : "border-parchment-300 text-slate-600 hover:bg-parchment-100"
          }`}
        >
          <input
            type="radio"
            name="plan"
            value={value}
            checked={plan === value}
            onChange={() => onChange(value)}
            className="sr-only"
          />
          <span>{label}</span>
          <span className="text-base font-semibold">{price}</span>
          <span className="text-xs font-normal opacity-70">{note}</span>
        </label>
      ))}
    </div>
  );
}
